// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paymentOptionRadioButton_radio__3aetR {\n  display: flex;\n  align-items: center;\n}", ""]);
// Exports
exports.locals = {
	"radio": "paymentOptionRadioButton_radio__3aetR"
};
module.exports = exports;
